// 裁處日期起訖區間上限（月）；供 layout.js 的 customCalendar 限制可選日期，只在本頁生效
window.calendarMaxRangeMonths = 60;

function VerifyHrefContent(params) {
  // 創建一個新的 URLSearchParams 來保存驗證後的參數
  const sanitizedParams = new URLSearchParams();

  // 迭代所有參數並進行驗證
  for (const [key, value] of params) {
    // 檢查鍵和值是否包含合法字符
    if (IsValidInput(key) && IsValidInput(value)) {
      // 將合法的參數加入到驗證後的參數中
      sanitizedParams.append(key, value);
    }
  }

  return sanitizedParams;
}

// 驗證輸入是否包含合法字符
function IsValidInput(input) {
  // 排除特定字符，允許英文日文中文等其他符號，for路標名稱
  const disallowedCharsRegex = /[<>\"']/;
  return !disallowedCharsRegex.test(input);
}

// 檢查裁處日期起訖區間是否在 5 年（含）以內，超過回傳 false
function IsDateRangeWithinLimit(startDate, endDate) {
  return moment(endDate).isSameOrBefore(moment(startDate).add(5, "years"));
}

// 檢查使用者輸入的起訖日期格式：有填的日期必須是 yyyy-mm-dd 且為存在的日期（例如 2026-02-30 不合法），未填不檢查
function IsValidDateFormat(data) {
  return [data.StartDate, data.EndDate].every((date) => {
    if (date === null || date === undefined || String(date).trim() === "") return true;
    return /^\d{4}-\d{2}-\d{2}$/.test(String(date).trim()) && moment(String(date).trim(), "YYYY-MM-DD", true).isValid();
  });
}

const DATE_FORMAT_ERROR_TEXT = "請輸入正確的日期格式！";

// 裁處書字號格式：[污染類別代碼 2 碼]-[年度 3 碼]-[流水號 6 碼]，例如 21-115-081147；空值視為未填
const DOCUMENT_NO_REGEX = /^\d{2}-\d{3}-\d{6}$/;
const DOCUMENT_NO_ERROR_TEXT = "請輸入正確的裁處書字號格式！";
function IsValidDocumentNo(value) {
  const v = (value || "").trim();
  return v === "" || DOCUMENT_NO_REGEX.test(v);
}

// 將特殊字符進行 HTML 轉義，防止 XSS 攻擊
function VerifyHtml(str) {
  // 使用 textContent 處理 HTML 特殊字符
  const div = document.createElement("div");
  div.textContent = str;
  return div.innerHTML;
}

let fetchData = {
  UniformNo: "",
  DocumentNo: "",
  FacilityName: "",
  County: "",
  PenaltyAgencyList: "",
  Regulations: "",
  Law: "",
  StartDate: "",
  EndDate: "",
  PageNumber: "",
  PageSize: "",
};
let mobile_fetchData = fetchData;
let pageData = [];
let pageDataRaw = [];
let paginationList = [];
let singlePageSize = 5;
let currentPageNo = 1;

window.onload = () => {
  document.title = "列管污染源資料 (含裁處資訊) 查詢系統-裁處資訊查詢結果";

  page_loader(true);
  PageInit();
  Search();
};

function PageInit() {
  fetchData = {
    UniformNo: urlParams.get("UniformNo") ? urlParams.get("UniformNo") : "",
    DocumentNo: urlParams.get("DocumentNo") ? urlParams.get("DocumentNo") : "",
    FacilityName: urlParams.get("FacilityName") ? urlParams.get("FacilityName") : "",
    County: urlParams.get("County") ? urlParams.get("County") : "",
    PenaltyAgencyList: urlParams.get("PenaltyAgencyList") ? urlParams.get("PenaltyAgencyList") : "",
    Regulations: urlParams.get("Regulations") ? urlParams.get("Regulations") : "",
    Law: urlParams.get("Law") ? urlParams.get("Law") : "",
    StartDate: urlParams.get("StartDate") || "",
    EndDate: urlParams.get("EndDate") || "",
    RegistrationNo: urlParams.get("RegistrationNo") ? urlParams.get("RegistrationNo") : "",
    PageNumber: 1,
    PageSize: -1,
  };
  mobile_fetchData = fetchData;
  PaginationSelectInit();
  FilterInit();
  // 資料下載
  $(".download_button").click(function (e) {
    // 由 DownloadPenaltyFile 以 fetch 下載，避免連結再觸發一次下載
    e.preventDefault();
    let obj = { ...fetchData, PageSize: -1 };
    delete obj.PageNumber;
    DownloadPenaltyFile($(this), obj);
  });
}

function Search() {
  $.ajax({
    url: `${host}api/v1/Penalty`,
    type: "GET",
    data: fetchData,
    headers: {
      Accept: "application/json",
    },
    success: function (res) {
      // 查詢條件不被接受時 API 只回 Result.Message、沒有 Data，視同查無資料，避免載入動畫一直轉
      pageDataRaw = (res && res.Result && res.Result.Data) || [];
      pageData = pageDataRaw;
      if (pageDataRaw.length > 0) {
        RefreshTable(pageData.slice(0, 5));
        CreatePagination(pageDataRaw.length);
        $(".result_number").text(pageDataRaw.length);
        $(".data_block").slideDown();
      } else {
        $(".flex_block .result_block .data_block").slideUp();
        if (!tabletMediaQuery.matches) {
          $(".page_search_block .search_result_block>.btn_group").slideUp();
        }
        $(".page_search_block .search_result_block").empty();
        let html = `<div class="no_data">
                                  <div class="text">找不到符合搜尋條件的裁處資訊</div>
                                  <ul>
                                  <li>建議您：</li>
                                  <li>1. 請檢查有無錯別字</li>
                                  <li>2. 請換用不同的查詢字詞</li>
                                  <li>3. 請減少查詢字詞</li>
                                  </ul>
                              </div>`;
        $(".page_search_block .search_result_block").append(html);
        $(".page_search_block .search_result_block .no_data").slideDown();
      }
      page_loader(false);
    },
    error: function () {
      page_loader(false);
    },
  });
}

function RefreshTable(obj) {
  $(".data").empty();
  let html = "";
  obj.forEach((r, i) => {
    html += ` <ul class="data_list">
                <li>
                    <div class="detail_info">
                        <div class="title">裁處日期</div>
                        <div class="text">${r.PENALTYDATE}</div>
                    </div>
                    <div class="detail_info">
                        <div class="title">管制編號</div>
                        <div class="text">${r.REGISTRATIONNO}</div>
                    </div>
                    <div class="detail_info">
                        <div class="title">事業名稱</div>
                        <div class="text">${r.FACILITYNAME}</div>
                    </div>
                    <div class="detail_info">
                        <div class="title">裁處機關</div>
                        <div class="text">${r.COUNTY}</div>
                    </div>
                    <div class="detail_info">
                        <div class="title">裁處書字號</div>
                        <div class="text">${r.DOCUMENTNO ? `${r.DOCUMENTNO}（<button class="TransgressState" data-index="${i}" aria-label="檢視違反事實 詳細內容">檢視違反事實</button>）` : `-`}</div>
                    </div>
                    <div class="detail_info">
                        <div class="title">違反日期</div>
                        <div class="text">${r.TRANSGRESSDATE}</div>
                    </div>
                    <div class="detail_info">
                        <div class="title">違反法令</div>
                        <div class="text">${r.TRANSGRESSLAW}</div>
                    </div>
                    <div class="detail_info">
                        <div class="title">裁處金額</div>
                        <div class="text font-bold">${r.PENALTYMONEY}</div>
                    </div>
                    <button class="more_info" data-index=${i}>詳細資訊</button>
                </li>
            </ul>`;
  });
  $(".data").append(html);

  // 檢視違反事實視窗
  $(" .detail_info>.text > button").click(function () {
    let index = $(this).data("index");
    let data = obj[index];
    let html = `<p>${data.TRANSGRESSSTATE}</p>`;
    $(".modal_block .modal_content").empty();
    $(".modal_block .modal_header > .title").text(`【違反事實】裁處書字號 ${data.DOCUMENTNO}`);
    $(".modal_block .modal_content").append(html);
    $(".modal_block .modal_content").addClass("height_auto");
    $(".modal_block").fadeIn();
    $(".modal_block").css("display", "flex");
    $("body").css("over", "hidden");
  });

  // 詳細資訊
  $(".data_list > li .more_info").click(function () {
    let index = $(this).data("index");
    let data = obj[index];
    let html = `<div class="ul_grid">
                <ul class="ul_block">
                  <li>
                    <div class="title">主旨</div>
                    <div class="text">${data.SUBJECT}</div>
                  </li>
                  <li>
                    <div class="title">裁處理由及法令</div>
                    <div class="text">${data.GISTDEFINE}</div>
                  </li>
                  <li>
                    <div class="title">限改日期</div>
                    <div class="text">${data.IMPROVEDEADLINE ? data.IMPROVEDEADLINE : "-"}</div>
                  </li>
                  <li>
                    <div class="title">改善完妥與否</div>
                    <div class="text">${data.ISIMPROVE}</div>
                  </li>
                  <li>
                    <div class="title">複查稽查結果</div>
                    <div class="text">${data.INSPECTIONCONDITION ? data.INSPECTIONCONDITION : "-"}</div>
                  </li>
                  <li>
                    <div class="title">複查稽查單稽查日期</div>
                    <div class="text">${data.INSPECTIONDATETIMES ? data.INSPECTIONDATETIMES : "-"}</div>
                  </li>                
                  <li>
                      <div class="title">違規人管制編號 
                        <div class="tooltip_btn" >
                          <img src="img/icon/circle-information.svg" class="svg">
                            <div class="tooltip">系統提供列管污染源及裁處兩類資訊，針對列管污染源之「管制編號」為8碼，主要作為申報、各式污染源許可申請時使用；而稽查裁處時使用之「稽查管制編號」為12碼。實務上執行稽查裁處時可直接以「管制編號」或是再給予一個「稽查管制編號」進行裁處，而造成於裁處資訊項下查詢時有2種管制編號的情形。
                            </div>
                        </div>
                      </div> 
                    <div class="text">${data.TRANSGRESSCONTROLID}</div>
                  </li>
                  <li>
                    <div class="title">違規人名稱</div>
                    <div class="text">${data.TRANSGRESSNAME}</div>
                  </li>
                  <li>
                    <div class="title">統一編號</div>
                    <div class="text">${data.FACUNIFORMNO ? data.FACUNIFORMNO : "-"}</div>
                  </li>
                  <li>
                    <div class="title">公司（工廠）地址</div>
                    <div class="text">${data.FACADDRESS}</div>
                  </li>
                  <li>
                    <div class="title">污染類別</div>
                    <div class="text">${data.TRANSGRESSTYPE}</div>
                  </li>
                  <li>
                    <div class="title">違反地址</div>
                    <div class="text">${data.TRANSGRESSADDRESS}</div>
                  </li> 
                  <li>
                    <div class="title">違反事實</div>
                    <div class="text">${data.TRANSGRESSSTATE}</div>
                  </li>          
                </ul>
                <ul class="ul_block">
                  <li>
                    <div class="title">情節重大</div>
                    <div class="text">${data.ISIMPORTANT !== "" ? data.ISIMPORTANT : "-"}</div>
                  </li>
                  <li>
                    <div class="title">其他處罰方式</div>
                    <div class="text">${data.PENALTYKIND}</div>
                  </li>
                  <li>
                    <div class="title">不法利得</div>
                    <div class="text">${data.ILLEGALMONEY}</div>
                  </li>
                  <li>
                    <div class="title">水污追繳不法利得</div>
                    <div class="text">${data.TRACKILLEGALMONEY}</div>
                  </li>
                  <li>
                      <div class="title">是否減免罰鍰</div>
                      <div class="text">${data.ISREDUCEMONEY !== "" ? data.ISREDUCEMONEY : "-"}</div>
                  </li>
                  <li>
                      <div class="title">罰鍰是否繳清</div>
                      <div class="text">${data.PAYMENTSTATE}</div>
                  </li>
                  <li>
                      <div class="title">是否進行催繳</div>
                      <div class="text">${data.ISREMINDER}</div>
                  </li>
                  <li>
                      <div class="title">是否行政移送</div>
                      <div class="text">${data.ISADMINCOURT}</div>
                  </li>
                  <li>
                    <div class="title">是否訴願訴訟</div>
                    <div class="text">${data.ISPETITION}</div>
                  </li>
                  <li>
                    <div class="title">訴願提出日期</div>
                    <div class="text">${data.LAWSUITDATE1 ? data.LAWSUITDATE1 : "-"}</div>
                  </li>
                  <li>
                    <div class="title">訴願訴訟結果</div>
                    <div class="text">${data.PETITIONRESULTS ? data.PETITIONRESULTS : "-"}</div>
                  </li>
                  <li>
                    <div class="title">陳情意見結果</div>
                    <div class="text">${data.APPEALRESCIND !== "" ? data.APPEALRESCIND : "-"}</div>
                  </li>
                  <li>
                    <div class="title">審議機關</div>
                    <div class="text">${data.PETITIONAGENCY !== "" ? data.PETITIONAGENCY : "-"}</div>
                  </li>                  
                  <li>
                    <div class="title">核准復工日期</div>
                    <div class="text">${data.ALLOW_REWORK_DATA !== "" ? data.ALLOW_REWORK_DATA : "-"}</div>
                  </li>  
                </ul>
            </div>
            <div class="description_block">
                <div class="title"><img src="img/icon/circle-information.svg" class="svg" alt="">違規人管制編號</div>
                <div class="text">系統提供列管污染源及裁處兩類資訊，針對列管污染源之「管制編號」為8碼，主要作為申報、各式污染源許可申請時使用；而稽查裁處時使用之「稽查管制編號」為12碼。實務上執行稽查裁處時可直接以「管制編號」或是再給予一個「稽查管制編號」進行裁處，而造成於裁處資訊項下查詢時有2種管制編號的情形。</div>
            </div>`;
    $(".modal_block .modal_content").empty();
    $(".modal_block .modal_header > .title").text(`【詳細資訊】裁處書字號 ${data.DOCUMENTNO}`);
    $(".modal_block .modal_content").append(html);
    $(".modal_block .modal_content").removeClass("height_auto");
    $(".modal_block").fadeIn();
    $(".modal_block").css("display", "flex");
    $("body").css("over", "hidden");
  });

  //   關閉MODAL按鈕
  $(".modal_footer > button").click(function () {
    $(".modal_block").fadeOut();
    $("body").css("over", "unset");
  });
  //   列印
  $(".modal_footer > .print").click(function () {
    $(".modal_print span").text(moment().format("YYYY/MM/DD HH:mm:ss"));
    window.print();
  });
}

function PaginationSelectInit() {
  document.querySelectorAll(".pagination_select .select_dropbox").forEach(function (parent) {
    Array.from(parent.children).forEach(function (child) {
      if (!child.classList.contains("disabled")) {
        let no = child.getAttribute("data-no");
        child.children[0].addEventListener("click", function () {
          singlePageSize = no === "0" ? pageData.length : parseInt(no);
          currentPageNo = 1;
          RefreshTable(pageData.slice(0, singlePageSize));
          CreatePagination(pageData.length);
          RefreshPagination();
        });
      }
    });
  });
}

// 建立換頁標籤
function CreatePagination(itemCount) {
  $(".pagination").html("");
  let maxPageNo = Math.ceil(itemCount / singlePageSize);
  paginationList = Array.from({ length: maxPageNo }, (value, index) => index + 1);

  let window = maxPageNo > 5 ? 5 : maxPageNo;
  let prevBtn = `<li class="prev disabled"><button type="button" title="上一頁" onclick="ChangePage('prev')"><img src="img/icon/chevron-left.svg" class="svg"></button></li>`;
  let nextBtn = `<li class="next ${maxPageNo == 1 ? "disabled" : ""}"><button type="button" title="下一頁" onclick="ChangePage('next')"><img class="svg" src="img/icon/chevron-right.svg"></button></li>`;

  $(".pagination").append(prevBtn);
  for (let i = 0; i < window; i++) {
    let numBtn = `<li class="${paginationList[i] == currentPageNo ? "active" : ""}"><button type="button" onclick="ChangePage(this)" title="前往第${paginationList[i]}頁">${paginationList[i]}</button></li>`;
    $(".pagination").append(numBtn);
  }
  $(".pagination").append(nextBtn);
}

function ChangePage(type) {
  switch (type) {
    case "prev":
      if (currentPageNo > 1) {
        currentPageNo--;
      }
      break;
    case "next":
      if (currentPageNo < paginationList[paginationList.length - 1]) {
        currentPageNo++;
      }
      break;
    default:
      currentPageNo = parseInt(type.innerText);
      break;
  }
  RefreshPagination();
  let startIndex = (currentPageNo - 1) * singlePageSize;
  let endIndex = (currentPageNo - 1) * singlePageSize + singlePageSize;
  RefreshTable(pageData.slice(startIndex, endIndex));
  const data_block = document.querySelector(".data_block");
  if (window.scrollY > data_block.offsetTop - 16) scrollTo(0, data_block.offsetTop - 16);
}

// 更新換頁標籤
function RefreshPagination() {
  let currentPaginationList = [];
  if (paginationList.length > 5) {
    if (currentPageNo <= 3) {
      currentPaginationList = Array.from({ length: 5 }, (value, index) => index + 1);
    } else {
      if (paginationList.slice(currentPageNo - 1).length >= 3) {
        currentPaginationList = paginationList.slice(currentPageNo - 3, currentPageNo + 2);
      } else {
        currentPaginationList = paginationList.slice(-5);
      }
    }
  } else {
    currentPaginationList = paginationList;
  }
  $(".pagination").each(function (idx, jqEl) {
    if (currentPageNo == 1) {
      jqEl.children[0].classList.add("disabled");
    } else {
      jqEl.children[0].classList.remove("disabled");
    }

    if (currentPageNo == paginationList.length) {
      jqEl.children[jqEl.childElementCount - 1].classList.add("disabled");
    } else {
      jqEl.children[jqEl.childElementCount - 1].classList.remove("disabled");
    }
    Array.from(jqEl.children).forEach(function (el, i) {
      if (i > 0 && i < jqEl.childElementCount - 1) {
        el.classList.remove("active");
        el.children[0].innerText = currentPaginationList[i - 1];
        if (parseInt(el.children[0].innerText) == currentPageNo) {
          el.classList.add("active");
        }
      }
    });
  });
}

function FilterInit() {
  $(".dropdown_option > li > a").click(function (e) {
    e.stopPropagation();
    let li = $(this).parent("li");
    if (li.hasClass("open")) {
      $(li).removeClass("open");
      this.setAttribute("aria-expanded", "false");
    } else {
      $(li).addClass("open");
      this.setAttribute("aria-expanded", "true");
    }
  });

  //   裁處日期
  customCalendar(fetchData.StartDate, fetchData.EndDate);
  $(".input_calendar_range > .calendar_input").each(function (e) {
    let type = $(this).find("input").data("type");
    $(this).find("input").val(fetchData[type]);
  });
  $(".calendar_input").val(`${fetchData.StartDate} ─ ${fetchData.EndDate}`);
  let selected_start = fetchData.StartDate;
  let selected_end = fetchData.EndDate;
  $(".calendar_icon").click((e) => e.stopPropagation());
  $(".calendar > .calender_content").delegate("table tbody td>button", "click", function () {
    if (selected_start === "") {
      selected_start = $(this).parent("td").data("date");
    } else if (selected_end === "") {
      selected_end = $(this).parent("td").data("date");
    } else if (selected_start !== "" && selected_end !== "") {
      selected_start = $(this).parent("td").data("date");
      selected_end = "";
    }
    let table_index = $(this).parent("td").parent("tr").parent("tbody").parent("table").data("index");
    // --- 程式碼路徑：js/layout.js ----- //
    customCalendar(selected_start, selected_end, table_index);
  });
  $(".clear_calendar").click(function () {
    selected_start = fetchData.StartDate;
    selected_end = fetchData.EndDate;
    // --- 程式碼路徑：js/layout.js ----- //
    customCalendar(selected_start, selected_end);
  });
  $(".calendar").delegate("table td>button", "click", function (e) {
    let type = $(this).parents(".calendar_input").children("input").data("type");
    let value = $(this).parent("td").data("date");
    // 點日期一律以該日為選取值，確保輸入框正確帶入（清除請用清除按鈕）
    let selectedValue = value;

    $(this).parents(".calendar").slideUp(100);
    $(this).parents(".calendar").removeClass("open");
    fetchData[type] = selectedValue;
    $(this).parents(".calendar_input").children("input").val(selectedValue);
    if (type === "StartDate") {
      fetchData.EndDate = "";
      customCalendar(selectedValue, fetchData.EndDate ? fetchData.EndDate : "", selectedValue);
    }
    $(".input_calendar_range > .calendar_input").each(function (e) {
      let type = $(this).find("input").data("type");
      $(this).find("input").val(fetchData[type]);
    });
    if (fetchData.StartDate && fetchData.EndDate) {
      let new_url = new URL(location.href);
      new_url.searchParams.set("StartDate", fetchData.StartDate);
      new_url.searchParams.set("EndDate", fetchData.EndDate);
      window.location.href = new_url.href;
    }
  });
  $(".calendar_input > input").keyup(function (e) {
    let value = $(this).val();
    let type = $(this).data("type");
    if (e.keyCode === 13) {
      fetchData[type] = value;
      $(this).next(".calendar").removeClass("open");
      $(this).next(".calendar").slideUp();
      $(".date_format_error").text("");
      if (!IsValidDateFormat(fetchData)) {
        $(".date_format_error").text(DATE_FORMAT_ERROR_TEXT);
        return;
      }
      if (fetchData.StartDate && fetchData.EndDate) {
        // 手動輸入時仍檢查區間，避免繞過日曆反灰送出超過 5 年的範圍
        if (!IsDateRangeWithinLimit(fetchData.StartDate, fetchData.EndDate)) {
          alert("裁處日期區間不得超過 5 年！");
          return;
        }
        let new_url = new URL(location.href);
        new_url.searchParams.set("StartDate", fetchData.StartDate);
        new_url.searchParams.set("EndDate", fetchData.EndDate);
        window.location.href = new_url.href;
      }
    }
  });

  // 裁處機關與違反法令
  const FETCHCODE = (Data) => {
    $(".select_dropbox").each(function () {
      let this_ = $(this);
      let type = $(this_).data("type");
      if (type) {
        if (type === "Law") {
          FetchPenaltyCode("", this_, type, Data, Data.Regulations, "");
        } else {
          FetchPenaltyCode("", this_, type, Data);
        }
      }
    });
  };
  FETCHCODE(fetchData);

  // 統一編號
  $(".id_submit").click(function (e) {
    let val = $(".dropdown .UniformNo").val();
    let new_url = new URL(location.href);
    new_url.searchParams.set("UniformNo", val);
    window.location.href = new_url.href;
  });

  // 裁處書字號（桌機）：格式錯誤時於輸入框下方顯示紅字，不送出
  const SubmitDocumentNo = () => {
    const input = $(".dropdown .DocumentNo");
    const errorBox = input.closest(".dropdown").find(".doc_no_error");
    const val = (input.val() || "").trim();
    errorBox.text("");
    if (!IsValidDocumentNo(val)) {
      errorBox.text(DOCUMENT_NO_ERROR_TEXT);
      return;
    }
    let new_url = new URL(location.href);
    if (val) {
      new_url.searchParams.set("DocumentNo", val);
    } else {
      new_url.searchParams.delete("DocumentNo");
    }
    window.location.href = new_url.href;
  };
  $(".doc_submit").click(SubmitDocumentNo);
  // 重新輸入時先清掉舊的錯誤訊息
  $(".DocumentNo").on("input", function () {
    $(this).closest("li").find(".doc_no_error").text("");
  });
  $(".dropdown .DocumentNo").keyup(function (e) {
    if (e.keyCode === 13) SubmitDocumentNo();
  });

  // 事業名稱
  $(".company_name").keyup(function (e) {
    if (e.keyCode === 13) {
      $(".error_name").text("");
      // 事業名稱為必填，空白（含只輸入空白字元）不查詢
      if (!e.target.value.trim()) {
        $(".error_name").text("請輸入事業名稱！");
        return;
      }
      fetchData.FacilityName = e.target.value;
      window.location.href = URLhref("FacilityName", fetchData.FacilityName);
    }
  });
  $(".company_name_btn, .filter_mobile_btn").click(function (e) {
    $(".error_name").text("");
    Array.from(document.querySelectorAll(".company_name")).forEach(function (el, index) {
      if (e.currentTarget.classList.contains("filter_mobile_btn")) {
        if (index == 0) {
          fetchData.FacilityName = el.value;
        }
      } else {
        if (index == 1) {
          fetchData.FacilityName = el.value;
        }
      }
    });
    // 事業名稱為必填，空白（含只輸入空白字元）不查詢
    if (!(fetchData.FacilityName || "").trim()) {
      $(".error_name").text("請輸入事業名稱！");
      return;
    }
    window.location.href = URLhref("FacilityName", VerifyHtml(fetchData.FacilityName));
  });

  // 預填
  $(".dropdown_option > li").each(function () {
    let type = $(this).data("type");
    let id = $(this).data("id");
    if (type) {
      let reform_type = type.indexOf("&") > -1 ? type.split("&") : type;
      if (typeof reform_type === "string") {
        if (fetchData[reform_type] && fetchData[reform_type] !== "") {
          $(this).addClass("open");
        }
      } else {
        let check = 0;
        reform_type.forEach((r) => {
          if (fetchData[r] !== "") {
            check = 1;
            return;
          }
        });
        if (check === 1) $(this).addClass("open");
      }
    } else if (id) {
      if (fetchData[id]) {
        $(this).addClass("open");
        $(`.${id}`).val(fetchData[id]);
      }
    }
  });
  $(".company_name").val(fetchData.FacilityName);

  // 裁處日期排序
  document.querySelector(".title_block.sort_button").addEventListener("click", function () {
    let open = this.classList.contains("open");
    this.querySelector(".title").innerText = open ? "裁處時間（舊到新）" : "裁處時間（新到舊）";
    SortPageData(this);
  });

  // 移動版
  $(".mobile_clear").click(function () {
    for (let key in fetchData) {
      if (key === "StartDate") {
        fetchData[key] = moment().subtract(5, "year").format("YYYY-MM-DD");
      } else if (key === "EndDate") {
        fetchData[key] = moment().format("YYYY-MM-DD");
      } else if (key !== "County" && key !== "FacilityName") {
        if (!!fetchData[key]) {
          fetchData[key] = "";
        }
      }
    }
    document.querySelector(".UniformNo").value = "";
    $(".DocumentNo").val("");
    $(".doc_no_error").text("");
    // ChangeUrlSearch();
  });
  $(".mobile_search").click(function () {
    fetchData.UniformNo = document.querySelector(".UniformNo").value;
    // 裁處書字號（移動版篩選面板）：格式錯誤時顯示紅字，不送出
    const mobileDocInput = $(".dropdown_form .DocumentNo");
    const mobileDocNo = (mobileDocInput.val() || "").trim();
    $(".dropdown_form .doc_no_error").text("");
    if (!IsValidDocumentNo(mobileDocNo)) {
      $(".dropdown_form .doc_no_error").text(DOCUMENT_NO_ERROR_TEXT);
      return;
    }
    fetchData.DocumentNo = mobileDocNo;
    ChangeUrlSearch();
  });
}

// 重組URL
function URLhref(param, page) {
  let new_url = new URL(location.href);
  let initial_href = "";
  if (urlParams.get(param)) {
    new_url.searchParams.set(param, page);
    initial_href = new_url.href;
  } else {
    initial_href = `${new_url}&${param}=${page}`;
  }
  return initial_href;
}

function ChangeUrlSearch() {
  let url = new URL(window.location.origin + window.location.pathname);
  Object.keys(fetchData).forEach(function (key) {
    if (!!fetchData[key]) {
      url.searchParams.set(key, fetchData[key]);
    }
  });
  window.location = url;
}

function SortPageData(el) {
  let sortType = "desc";
  if (el.classList.contains("open")) sortType = "asc";
  switch (sortType) {
    case "asc":
      pageData.sort(function (a, b) {
        return new Date(a.PENALTYDATE) > new Date(b.PENALTYDATE) ? 1 : -1;
      });
      break;
    case "desc":
      pageData.sort(function (a, b) {
        return new Date(a.PENALTYDATE) < new Date(b.PENALTYDATE) ? 1 : -1;
      });
      break;
  }
  currentPageNo = 1;
  RefreshTable(pageData.slice(0, singlePageSize));
  CreatePagination(pageData.length);
  RefreshPagination();
}
